
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { i18n } from '@/plugins/i18n';
@Component({
  components: {},
})
export default class PasswordIndicator extends Vue {
  @Prop(String) passwordText;
  private passwordValidationConstructs: any[] = [
    {
      text: i18n.t('PasswordIndicator_MinimumCharacters'),
      validationFunction: function() {
        if (this.value && this.value.length >= this.fieldParamValue) {
          return true;
        }
        return false;
      },
      value: '',
      valid: -1,
      passwordCheckCompleted: -1,
      fieldName: 'MIN_PASSWORD_LENGTH',
      fieldParamValue: 8,
    },
    {
      text: i18n.t('PasswordIndicator_AtLeastUppercase'),
      validationFunction: function() {
        let upperCaseLetters = /[A-Z]/g;
        if (
          this.value &&
          this.value.match(upperCaseLetters) &&
          this.value.match(upperCaseLetters).length >= this.fieldParamValue
        ) {
          return true;
        }
        return false;
      },
      value: '',
      valid: -1,
      passwordCheckCompleted: -1,
      fieldName: 'MIN_UPPERCASE_CHARS',
      fieldParamValue: 1,
    },
    {
      text: i18n.t('PasswordIndicator_AtLeastNumber'),
      validationFunction: function() {
        let numbers = /[0-9]/g;
        if (
          this.value &&
          this.value.match(numbers) &&
          this.value.match(numbers).length >= this.fieldParamValue
        ) {
          return true;
        }
        return false;
      },
      value: '',
      valid: -1,
      passwordCheckCompleted: -1,
      fieldName: 'MIN_NUMBER_CHARS',
      fieldParamValue: 1,
    },
    {
      text: i18n.t('PasswordIndicator_AtLeastSpecialCharacter'),
      validationFunction: function() {
        let allowedSpecialChars = /[@%+/'!#$^?:,(){}[~`_-]/g;
        let specialChars = /[\W\_]/g;
        if (
         (this.value && this.value.match(allowedSpecialChars) && this.value.match(allowedSpecialChars).length >= this.fieldParamValue) && 
          (this.value.match(allowedSpecialChars).length == this.value.match(specialChars).length)
        ) {
          return true;
        }
        return false;
      },
      value: '',
      valid: -1,
      passwordCheckCompleted: -1,
      fieldName: 'MIN_SPECIAL_CHARS',
      fieldParamValue: 1,
    }
  ];

  private passwordStrengthConditions: any = [];

  @Watch('passwordText')
  passwordChange(newVal) {
    for (let passwordCheck of this.passwordStrengthConditions) {
      passwordCheck.value = this.passwordText;
      passwordCheck.valid = passwordCheck.validationFunction.apply(
        passwordCheck,
      );
    }
    let passwordRequirementMatches =
      this.passwordStrengthConditions.filter((pass) => !pass.valid).length == 0;
    this.$emit('passwordstatus', passwordRequirementMatches);
  }

  mounted() {
    let arr: any[] = [];
    for (let passwordCheck of this.passwordValidationConstructs) {
      if (vxm.configs.getGlobalConfigValue(passwordCheck.fieldName)) {
        passwordCheck.value = this.passwordText;
        passwordCheck.fieldParamValue = vxm.configs.getGlobalConfigValue(passwordCheck.fieldName);
        passwordCheck.text = passwordCheck.text
          ? passwordCheck.text.replace('{value}', passwordCheck.fieldParamValue)
          : passwordCheck.text;
        passwordCheck.valid = passwordCheck.validationFunction.apply(
          passwordCheck,
        );
        arr.push(passwordCheck);
      }
    }
    this.passwordStrengthConditions = arr;
  }
}
